import get from 'lodash/get'
import { Controller, useFormContext } from 'react-hook-form'
import { Component } from './components/Component'

import type { DatePickerProps } from './types'

export const DatePicker = ({
  name,
  label,
  placeholder,
  required,
  error,
  hasController = true,
  onChange,
  ...rest
}: DatePickerProps) => {
  if (hasController) {
    const { control } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Component
            name={name}
            label={label}
            placeholder={placeholder}
            required={required}
            error={get(errors, name)?.message as string}
            value={field.value}
            onChange={field.onChange}
            {...rest}
          />
        )}
      />
    )
  }

  return (
    <Component
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      error={error}
      onChange={onChange ?? (() => {})}
      {...rest}
    />
  )
}
